<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="New"
      @click="fnShowModal()"
    >
      New
    </button>

    <b-modal ref="modal" size="lg" hide-footer title="EM Document - New">
      <div class="d-block">
        <form v-on:submit.prevent="createNew">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="title"
                  placeholder=""
                  v-model="title"
                />
                <label class="floatingLabel" for="title">Title</label>
                <div class="invalid-feedback" v-if="errors.title">
                  {{ errors.title[0] }}
                </div>
              </div>
              <!-- <label for="name"></label> -->
              <div class="sits-file-upload">
                <input
                  type="file"
                  id="actual-btn"
                  ref="file"
                  @change="uploadFile"
                  hidden
                />
                <!-- our custom upload button -->
                <label class="upload-label" for="actual-btn"
                  ><i class="fas fa-cloud-upload-alt text-primary"></i> Upload
                  file</label
                >

                <!-- name of file chosen -->
                <span v-if="document.name" id="file-chosen">{{
                  document.name
                }}</span>
                <span v-else-if="url" id="file-chosen"
                  ><a :href="`${url}`" target="_blank">Document</a></span
                >
                <span id="file-chosen" v-else>No file chosen</span>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="form-group">
                <textarea
                  rows="5"
                  type="text"
                  class="form-control"
                  id="description"
                  placeholder=" "
                  autocomplete="off_description"
                  v-model="description"
                />
                <label class="floatingLabel" for="description"
                  >Description</label
                >
              </div>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as messageService from '../../services/message.service'
import * as emService from '../../services/em.service'
export default {
  name: 'ModalEMDocumentNew',
  components: {},
  data() {
    return {
      errors: {},
      document: '',
      title: '',
      url: '',
      description: '',
      isSpinner: false
    }
  },
  computed: {
    ...mapGetters(['getEMDocumentPaginate'])
  },
  methods: {
    ...mapActions(['fetchEMDocumentPaginate']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    createNew: async function () {
      this.isSpinner = true
      let formData = new FormData()
      formData.append('title', this.title)
      formData.append('description', this.description)
      formData.append('url', this.url)
      formData.append('file', this.document)

      try {
        const response = await emService.addDocument(formData)

        this.fetchEMDocumentPaginate(this.getEMDocumentPaginate)
        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'EM Document - new',
          'added successfully'
        )

        this.url = ''
        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'EM Document - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'EM Document - new',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    },
    uploadFile() {
      this.document = this.$refs.file.files[0]
    }
  }
}
</script>
